<template>
  <toast ref="toast" />

  <h2 class="container-md mt-4">{{$t("manage.users.title_index")}}</h2>

    <nav class="container my-4 text-break text-muted">
      <a class="link-primary text-decoration-underline"
         href="">
        <!--ToDo:管理者メニューに戻る-->
        {{$t("items.operational_management")}}
      </a>
      <span class="mx-3">&gt;</span>
      <span>{{$t("manage.users.title_index")}}</span>
    </nav>

    <section class="container my-4">
      <button type=button class="btn btn-outline-primary"
              data-bs-toggle="collapse" aria-expanded="false" data-bs-target="#search__area">
        {{$t("buttons.filter")}}
      </button>
      <div id="search__area" class="collapse row row-cols-1 row-cols-md-3 py-4 my-4 border-top border-bottom">
        <section class="d-flex flex-column justify-content-end col my-2">
          <label>{{$t("items.login_code")}}</label>
          <input type="text" class="form-control" v-model="userId" />
        </section>
        <section class="d-flex flex-column justify-content-end col my-2">
          <label>{{$t("items.name")}}</label>
          <input type="text" class="form-control" v-model="userName" />
        </section>
        <section class="d-flex flex-column justify-content-end col my-2">
          <label>{{$t("items.email")}}</label>
          <input type="email" class="form-control" v-model="email" />
        </section>
        <section class="d-flex flex-column justify-content-end col my-2">
          <label>{{$t("manage.users.group")}}</label>
          <select class="form-select">
          </select>
        </section>
        <section class="d-flex flex-column justify-content-end col my-2">
          <label>{{$t("items.permission")}}</label>
          <select class="form-select">
          </select>
        </section>
        <section class="d-flex flex-column justify-content-end col my-2">
          <label>{{$t("manage.users.masterdata")}}</label>
          <input type="text" class="form-control" v-model="masterData" />
        </section>
        <master-fields mode="search"
                       class="d-flex flex-column justify-content-end col my-2"
                       dateClass="d-flex flex-column justify-content-end col-md-8 my-2"/>
        <section class="col-md-12 my-2 text-end">
          <button v-on:click="onSearchClick" type=button class="ms-auto btn btn-outline-primary">
            {{$t("buttons.search")}}
          </button>
        </section>
      </div>
    </section>

    <section class="container-md text-end">
      <div class="btn-group">
        <button id="btnGroupDrop" type=button class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          {{$t("buttons.other")}}
          <ul class="dropdown-menu" aria-labelledby="btnGroupDrop">
            <li>
              <span class="dropdown-item" v-on:click="onBulkUpdateClick">
                {{$t("buttons.bulk_update")}}
              </span>
              <hr class="dropdown-divider" />
              <span class="dropdown-item" v-on:click="onOutputExcelClick">
                {{$t("buttons.excel_output")}}
              </span>
            </li>
          </ul>
        </button>
      </div>
      <a v-on:click="onAddClick" class="btn btn btn-outline-primary ms-2">
        {{$t("buttons.add")}}
      </a>
    </section>

    <section class="container my-4 p-5 bg-light text-center" v-if="dispNotFound && records.length == 0">
      <span>{{$t("errors.not_found")}}</span>
    </section>

  <section class="table-responsive container-xxl mt-4" v-if="records.length > 0">
    <table class="table table-striped table-hover border-top m-0" v-if="records.length > 0">
      <thead>
        <tr class="text-center">
          <th>
            <sort-container name="LoginCode"
                            v-on:sort="sorting"
                            :selectedItemName="query.columnName"
                            :direction="query.direction">
              {{$t("items.login_code")}}
            </sort-container>
          </th>
          <th>
            <sort-container name="Name"
                            v-on:sort="sorting"
                            :selectedItemName="query.columnName"
                            :direction="query.direction">
              {{$t("items.name")}}
            </sort-container>
          </th>
          <th>
            <sort-container name="Email"
                            v-on:sort="sorting"
                            :selectedItemName="query.columnName"
                            :direction="query.direction">
              {{$t("items.email")}}
            </sort-container>
          </th>
          <th>
            <sort-container name="GroupCode"
                            v-on:sort="sorting"
                            :selectedItemName="query.columnName"
                            :direction="query.direction">
              {{$t("items.group_code")}}
            </sort-container>
          </th>
          <th>
            <sort-container name="GroupName"
                            v-on:sort="sorting"
                            :selectedItemName="query.columnName"
                            :direction="query.direction">
              {{$t("items.group_name")}}
            </sort-container>
          </th>
          <template v-for="mf in masterFields">
            <th v-if="mf.isEnabled">
              <sort-container :name="'MasterField.' + mf.id"
                              v-on:sort="sorting"
                              :selectedItemName="query.columnName"
                              :direction="query.direction">
                {{mf.name}}
              </sort-container>
            </th>
          </template>
          <th>
            <sort-container name="Role"
                            v-on:sort="sorting"
                            :selectedItemName="query.columnName"
                            :direction="query.direction">
              {{$t("items.permission")}}
            </sort-container>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr class="text-nowrap"
            v-for="(record, index) in records" v-bind:key="record.id">
          <td class="col-1">
            <a class="link-primary"
                v-bind:href='`/Manage/Users/Edit?id=${record.id}`'>
              {{record.loginCode}}
            </a>
          </td>
          <td class="col-2">
            {{record.name}}
          </td>
          <td class="col-2">
            {{record.email}}
          </td>
          <td class="text-center col-2">
            {{record.userGroups[0]?.groupCode}}
          </td>
          <td class="text-center col-2">
            {{record.userGroups[0]?.parentGroupId === null ? record.userGroups[0]?.groupName : groups?.find(g => g.id === record.userGroups[0]?.id)?.groupName}}
          </td>

          <template v-for="mf in masterFields">
            <td v-if="mf.isEnabled">
              {{record.userAdditionalData.find(uad => uad.masterFieldId === mf.id)?.masterData}}
            </td>
          </template>

            <td class="text-center col-2">
              {{record.userRoles[0]?.name}}
            </td>
            <td class="text-start col-auto position-relative">
              <button type="button"
                      class="btn p-0 shadow-none border-0"
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      v-bind:data-bs-target="'#dropdown-menu' + record.id">
                <svgicon name="threeDots" />
              </button>
              <ul v-bind:id="'dropdown-menu' + record.id"
                  class="collapse collapse-horizontal list-group list-group-horizontal list-unstyled position-absolute bg-white top-50 end-100 translate-middle-y">
                <li>
                  <button type="button" class="btn btn-link border-start" v-on:click="onEditClick(record, $event)">{{$t("buttons.edit")}}</button>
                </li>
                <li>
                  <button type="button" class="btn btn-link border-start text-danger" v-on:click="onDeleteClick(record, $event)">{{$t("buttons.delete")}}</button>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </section>

  <pagination-nav class="container-xxl p-0 mb-md-4"
                  v-on:move="paging"
                  v-on:limitChange="limitChange"
                  :limit="query.limit"
                  :offset="query.offset"
                  :count="count"
                  :range="0"
                  :buttonAlwaysVisible="true"
                  breakpoint="md"
                  shortSize="lg"
                  v-if="records.length > 0" />

  <div id="excel-output-modal" class="modal fade" tabindex="-1"
        data-bs-backdrop="static" aria-hidden="true"
        data-bs-keyboard="false">
    <div class="modal-dialog modal-xl">
      <div class="user__list-operation-modal modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t("items.excel_output",{ target: $t("manage.users.title_index") })}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="container my-4 overflow-auto">
          {{$t("messages.excel_output_description",{ target: $t("manage.users.title_index") })}}
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success" data-bs-dismiss="modal" aria-label="Close">
            {{$t("buttons.cancel")}}
          </button>
          <button type="button" class="btn btn btn-outline-primary ms-auto" v-on:click="OutputExcel()">
            {{$t("buttons.excel_output")}}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div id="bulk-update-modal" class="modal fade" tabindex="-1"
       data-bs-backdrop="static" aria-hidden="true"
       data-bs-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-xl">
      <div class="user__bulk-update-modal modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t("manage.users.title_bulk_update")}}</h5>
          <button type="button" class="btn-close" v-on:click="modalClose"></button>
        </div>

        <progress-nav :list="phaseList"
                      ref="progressNav"
                      class="container my-4"
                      breakpoint="sm"
                      v-on:move="shiftPhase" />

        <section v-show="this.phase === 0">
          <p class="container">{{$t("manage.users.balk_update_description_phase_1")}}</p>

          <section class="container my-4">
            <button type=button class="btn btn-outline-primary"
                    data-bs-toggle="collapse" aria-expanded="false" data-bs-target="#modal__lsearch__area">
              {{$t("buttons.filter")}}
            </button>
            <div id="modal__lsearch__area" class="collapse row row-cols-1 row-cols-md-3 py-4 my-4 border-top border-bottom">
              <section class="d-flex flex-column justify-content-end col my-2">
                <label>{{$t("items.login_code")}}</label>
                <input type="text" class="form-control" v-model="modalUserId" />
              </section>
              <section class="d-flex flex-column justify-content-end col my-2">
                <label>{{$t("items.name")}}</label>
                <input type="text" class="form-control" v-model="modalUserName" />
              </section>
              <section class="d-flex flex-column justify-content-end col my-2">
                <label>{{$t("items.email")}}</label>
                <input type="email" class="form-control" v-model="modalEmail" />
              </section>
              <section class="d-flex flex-column justify-content-end col my-2">
                <label>{{$t("manage.users.group")}}</label>
                <select class="form-select">
                </select>
              </section>
              <section class="d-flex flex-column justify-content-end col my-2">
                <label>{{$t("items.permission")}}</label>
                <select class="form-select">
                </select>
              </section>
              <section class="d-flex flex-column justify-content-end col my-2">
                <label>{{$t("manage.users.masterdata")}}</label>
                <input type="text" class="form-control" v-model="masterData" />
              </section>
              <section class="col-md-12 my-2 text-end">
                <button v-on:click="onModalSearchClick" type=button class="ms-auto btn btn-outline-primary">
                  {{$t("buttons.search")}}
                </button>
              </section>
            </div>
          </section>

          <section class="container my-4 p-5 bg-light text-center" v-if="dispNotFoundModal">
            <span>{{$t("errors.not_found")}}</span>
          </section>

          <section class="table-responsive container-xxl mt-4" v-if="records.length > 0">
            <table class="table table-striped table-hover border-top m-0" v-if="modalRecords.length > 0">
              <thead>
                <tr class="text-center">
                  <th>
                    <input class="form-check-input" type="checkbox" v-on:change="onAllCheckChange(modalRecords)" v-model="isAllCheck" id="allCheck">
                  </th>
                  <th nowrap>
                    {{$t("items.login_code")}}
                  </th>
                  <th nowrap>
                    {{$t("items.name")}}
                  </th>
                  <th nowrap>
                    {{$t("items.email")}}
                  </th>
                  <th nowrap>
                    {{$t("items.group_code")}}
                  </th>
                  <th nowrap>
                    {{$t("items.group_name")}}
                  </th>
                  <template v-for="mf in masterFields">
                    <th v-if="mf.isEnabled" nowrap>
                      {{mf.name}}
                    </th>
                  </template>
                  <th>
                    {{$t("items.permission")}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-nowrap"
                    v-for="(modalRecord, index) in modalRecords.slice(this.modalOffset, this.modalOffset + this.modalLimit)" v-bind:key="modalRecord.id">
                  <td class="text-center">
                    <input class="form-check-input" type="checkbox" v-model="modalRecord.isOperand"
                           v-on:click="modalRecord.isOperand = modalRecord.isOperand ? false : true; allCheckIndeterminate();">
                  </td>
                  <td class="col-1">
                    {{modalRecord.loginCode}}
                  </td>
                  <td class="col-2">
                    {{modalRecord.name}}
                  </td>
                  <td class="col-2">
                    {{modalRecord.email}}
                  </td>
                  <td class="text-center col-2">
                    {{modalRecord.userGroups[0]?.groupCode}}
                  </td>
                  <td class="text-center col-2">
                    {{modalRecord.userGroups[0]?.parentGroupId === null ? modalRecord.userGroups[0]?.groupName : groups?.find(g => g.id === modalRecord.userGroups[0]?.id)?.groupName}}
                  </td>

                  <template v-for="mf in masterFields">
                    <td v-if="mf.isEnabled">
                      {{modalRecord.userAdditionalData.find(uad => uad.masterFieldId === mf.id)?.masterData}}
                    </td>
                  </template>

                  <td class="text-center col-2">
                    {{modalRecord.userRoles[0]?.name}}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

          <pagination-nav class="container-xxl p-0 mb-md-4"
                          v-on:move="pagingForModal"
                          v-on:limitChange="limitChangeForModal"
                          :limit="modalLimit"
                          :offset="modalOffset"
                          :count="modalCount"
                          :range="0"
                          :buttonAlwaysVisible="true"
                          breakpoint="md"
                          shortSize="lg"
                          v-if="modalRecords.length > 0" />
        </section>

        <section v-show="this.phase === 1">
          <p class="container">{{$t("manage.users.balk_update_description_phase_2")}}</p>

          <div class="container my-4">
            <input type="radio"
                   id="passwordInit"
                   v-model="operation"
                   name="operation"
                   value="0"
                   checked />
            <span class="user__whitespace" />
            <label for="passwordInit">{{$t("manage.users.password_init")}}</label>
          </div>

          <div class="container my-4">
            <input type="radio"
                   id="userDelete"
                   v-model="operation"
                   name="operation"
                   value="1" />
            <span class="user__whitespace" />
            <label for="userDelete">{{$t("manage.users.user_delete")}}</label>
          </div>
        </section>

        <section v-show="this.phase === 2">
          <p class="container">{{confirmMessage}}</p>

          <section class="table-responsive container-xxl mt-4">
            <table class="table table-striped table-hover border-top m-0">
              <thead>
                <tr class="text-center">
                  <th nowrap>
                    {{$t("items.login_code")}}
                  </th>
                  <th nowrap>
                    {{$t("items.name")}}
                  </th>
                  <th nowrap>
                    {{$t("items.email")}}
                  </th>
                  <th nowrap>
                    {{$t("items.group_code")}}
                  </th>
                  <th nowrap>
                    {{$t("items.group_name")}}
                  </th>
                  <template v-for="mf in masterFields">
                    <th v-if="mf.isEnabled" nowrap>
                      {{mf.name}}
                    </th>
                  </template>
                  <th nowrap>
                    {{$t("items.permission")}}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-nowrap"
                    v-for="(target, index) in targetList.slice(this.modalOffsetConfirm, this.modalOffsetConfirm + this.modalLimitConfirm)" v-bind:key="target.id">
                  <td class="col-1">
                    {{target.loginCode}}
                  </td>
                  <td class="col-2">
                    {{target.name}}
                  </td>
                  <td class="col-2">
                    {{target.email}}
                  </td>
                  <td class="text-center col-2">
                    {{target.userGroups[0]?.groupCode}}
                  </td>
                  <td class="text-center col-2">
                    {{target.userGroups[0]?.parentGroupId === null ? target.userGroups[0]?.groupName : groups?.find(g => g.id === target.userGroups[0]?.id)?.groupName}}
                  </td>

                  <template v-for="mf in masterFields">
                    <td v-if="mf.isEnabled">
                      {{target.userAdditionalData.find(uad => uad.masterFieldId === mf.id)?.masterData}}
                    </td>
                  </template>

                  <td class="text-center col-2">
                    {{target.userRoles[0]?.name}}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

          <pagination-nav class="container-xxl p-0 mb-md-4"
                          v-on:move="pagingForModalConfirm"
                          v-on:limitChange="limitChangeForModalConfirm"
                          :limit="modalLimitConfirm"
                          :offset="modalOffsetConfirm"
                          :count="targetList.length"
                          :range="0"
                          :buttonAlwaysVisible="true"
                          breakpoint="md"
                          shortSize="lg" />
        </section>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-success" v-on:click="onModalPrevClick">{{$t("buttons.return")}}</button>
          <button type="button" class="btn btn btn-outline-primary ms-auto" v-on:click="onNextClick">
            {{nextButtonString}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent } from "vue";
  import { xhrRequest, xhrErrors, xhrSummaryErrors } from "utils/xhr";
  import Spinner from "utils/spinner";
  import { Modal } from "bootstrap";
  import SortContainer from "components/container/sort_container";
  import AlertToast from "components/toast/alert_toast";
  import PaginationNav from "components/nav/pagination_nav";
  import ProgressNav from "components/nav/progress_nav";
  import MasterFieldsInput from "components/input/master_fields_input";
  import { buildUrl } from "utils/url";

  const computed = {
    phaseList() {
      return [
        this.$t("manage.users.phase_user_select"),
        this.$t("manage.users.phase_operation_select"),
        this.$t("items.confirm"),
      ]
    },
    nextButtonString() {
      if (this.phase === 2) {
        return this.$t("items.execution");
      }
      return this.$t("buttons.next");
    },
    confirmMessage() {
      if (this.operation === "0") {
        return this.$t("manage.users.balk_update_password_initialize");
      }
      return this.$t("messages.delete_target", { target: this.$t("manage.users.target_user") });
    },
  };

  const methods = {
    loadRecords() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      let spinner = new Spinner();

      // マスター項目取得
      this.getMasterFields();

      // ユーザー情報取得
      this.getUser(spinner);
    },
    getMasterFields() {
      xhrRequest(
        "GET",
        "manage/masterFields",
        {
          limit: this.query.limit,
          offset: this.query.offset,
          columnName: "Id",
          direction: "asc"
        },
        {
          success: data => {
            this.masterFields = data.masterFields;
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
          },
          complete: () => {
            this.scrollTop();
            this.loading = false;
          }
        }
      );
    },
    getUser(spinner) {
      this.query.loginCode = "";
      this.query.userName = "";
      this.query.email = "";

      xhrRequest(
        "GET",
        "manage/users",
        this.query,
        {
          success: data => {
            this.records = data.users;
            this.groups = data.groups;
            this.count = data.count;
            this.dispNotFound = this.count == 0 ? true : false;
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
            this.dispNotFound = true;
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
            this.scrollTop();
          }
        }
      );
    },
    searchUser() {
      let spinner = new Spinner();
      this.query.loginCode = this.userId;
      this.query.userName = this.userName;
      this.query.email = this.email;

      xhrRequest(
        "GET",
        "manage/users",
        this.query,
        {
          success: data => {
            this.records = data.users;
            this.count = data.count;
            this.dispNotFound = this.count == 0 ? true : false;
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
            this.dispNotFound = true;
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
            this.scrollTop();
          }
        }
      );
    },
    onSearchClick() {
      if (this.userId == "" && this.userName == "" && this.email == "") {
        this.filtering = false;
      }
      else {
        this.filtering = true;
      }
      this.query.offset = 0;
      this.searchUser();
    },
    onOutputExcelClick() {
      if (this.dispNotFound) {
        alert(this.$t("errors.not_found"));
        return;
      }

      this.excelModal.show();
    },
    OutputExcel() {
      // ToDo:Excel出力処理

      // 通知を表示
      this.$refs.toast.createToast({
        title: "",
        body: this.$t("messages.start_excel_output"),
        isSimpleLayout: true,
      });
      this.$refs.toast.show();
    },
    onAddClick() {
      window.location.href = "/Manage/Users/Edit";
    },
    onEditClick(record) {
      window.location.href = buildUrl("/Manage/Users/Edit", { id: record.id });
    },
    onDeleteClick(record) {
      window.location.href = buildUrl("/Manage/Users/Edit", { id: record.id });
    },
    onBulkUpdateClick() {
      if (this.dispNotFound) {
        alert(this.$t("errors.not_found"));
        return;
      }
      // 一覧用にデータを取得
      this.getUserForModal();

      // 最初のフェーズに戻す
      this.$refs.progressNav.movePhase(0);

      // 一括更新モーダル表示
      this.bulkUpdateModal.show();
    },
    sorting(status) {
      this.query.columnName = status.name;
      this.query.direction = status.direction;
      this.query.offset = 0;
      this.loadRecords();
    },
    paging(status) {
      this.query.offset = status.paginationOffset;
      if (this.filtering) {
        this.searchUser();
      }
      else {
        this.loadRecords();
      }
    },
    limitChange(status) {
      this.query.offset = 0;
      this.query.limit = status.limit;

      if (this.filtering) {
        this.searchUser();
      }
      else {
        this.loadRecords();
      }
    },
    scrollTop: () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

// --------- 一括更新モーダル用メソッド ----------
    onModalPrevClick() {
      if (this.phase <= 0) {
        this.modalClose();
        return;
      }
      // 前のフェーズに戻る
      this.$refs.progressNav.movePrevPhase();
    },
    onNextClick() {
      if (this.phase === 0) {
        if (!this.modalRecords.some(t => t.isOperand)) {
          alert(this.$t("errors.not_selected_execution_target"));
          return;
        }
        this.targetList = Object.assign([], this.modalRecords.filter(u => u.isOperand));
      }
      if (this.phase === 2) {
        if (this.operation === "0") {
          this.bulkPasswordInit();
        }
        else {
          this.bulkDelete();
        }
      }
      this.$refs.progressNav.moveNextPhase();
    },
    shiftPhase(data) {
      this.phase = data.phase;
    },
    getUserForModal() {
      let spinner = new Spinner();
      this.modalQuery.loginCode = this.filtering ? this.userId : "";
      this.modalQuery.userName = this.filtering ? this.userName : "";
      this.modalQuery.email = this.filtering ? this.email : "";
      this.modalQuery.modalLoginCode = this.modalFiltering ? this.modalUserId : "";
      this.modalQuery.modalUserName = this.modalFiltering ? this.modalUserName : "";
      this.modalQuery.modalEmail = this.modalFiltering ? this.modalEmail : "";

      xhrRequest(
        "GET",
        "manage/users/GetUsersForModal",
        this.modalQuery,
        {
          success: data => {
            this.modalRecords = data.users;
            this.modalCount = this.modalRecords.length;
            this.dispNotFoundModal = data.count === 0;

            this.allCheckIndeterminate(this.modalRecords);
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
            this.dispNotFoundModal = true;
          },
          complete: () => {
            spinner.stop();
            this.loading = false;
            this.scrollTop();
          }
        }
      );
    },
    onModalSearchClick() {
      if (this.modalUserId === "" && this.modalUserName === "" && this.modalEmail === "") {
        this.modalFiltering = false;
      }
      else {
        this.modalFiltering = true;
      }
      this.isAllCheck = true;
      this.modalQuery.offset = 0;
      this.getUserForModal();
    },
    onAllCheckChange() {
      for (var i = 0; i < this.modalRecords.length; i++) {
        this.modalRecords[i].isOperand = this.isAllCheck;
      }
    },
    modalClose() {
      // モーダルの設定をクリア
      this.modalUserId = "";
      this.modalUserName = "";
      this.modalEmail = "";
      this.operation = "0";
      this.isAllCheck = true;
      this.modalLimit = 20;
      this.modalOffset = 0;

      // モーダルを閉じる
      this.bulkUpdateModal.hide();
    },
    allCheckIndeterminate() {
      let target = document.getElementById("allCheck");
      if (target === null) {
        return;
      } else {
        if (this.modalRecords.some(u => u.isOperand)
          && !this.modalRecords.every(u => u.isOperand)) {
          target.indeterminate = true;
          this.allCheck = false;
        } else if (this.modalRecords.every(u => u.isOperand)) {
          target.indeterminate = false;
          this.allCheck = true;
        } else {
          target.indeterminate = false;
          this.allCheck = false;
        }
      }
    },
    bulkPasswordInit() {
      if (!confirm(this.$t("manage.users.bulk_password_init_confirm"))) return;

      if (this.loading) {
        return;
      }
      this.loading = true;
      let spinner = new Spinner();

      xhrRequest(
        "PUT",
        "manage/users/BulkPasswordInitilize",
        this.targetList,
        {
          success: data => {
            // 通知を表示
            this.$refs.toast.storeToast({
              title: "",
              body: this.$t("manage.users.password_init_completed"),
              isSimpleLayout: true,
            });

            window.location.href = "/Manage/Users";

            return;
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
          },
          complete: () => {
            this.scrollTop();
            this.loading = false;
            spinner.stop();
          }
        }
      );
    },
    bulkDelete() {
      if (!confirm(this.$t("manage.users.user_delete_confirm"))) return;

      if (this.loading) {
        return;
      }
      this.loading = true;
      let spinner = new Spinner();

      xhrRequest(
        "POST",
        "manage/users/BulkDelete",
        this.targetList,
        {
          success: data => {
            // 通知を表示
            this.$refs.toast.storeToast({
              title: "",
              body: this.$t("messages.operation_completed", { operation: this.$t("buttons.delete") }),
              isSimpleLayout: true,
            });

            window.location.href = "/Manage/Users";

            return;
          },
          error: (xhr, status, error) => {
            this.errors = xhrErrors(xhr);
            this.summaryErrors = xhrSummaryErrors(xhr);
          },
          complete: () => {
            this.scrollTop();
            this.loading = false;
            spinner.stop();
          }
        }
      );
    },
    pagingForModal(status) {
      this.modalOffset = status.paginationOffset;
    },
    limitChangeForModal(status) {
      this.modalOffset = 0;
      this.modalLimit = status.limit;
    },
    pagingForModalConfirm(status) {
      this.modalOffsetConfirm = status.paginationOffset;
    },
    limitChangeForModalConfirm(status) {
      this.modalOffsetConfirm = 0;
      this.modalLimitConfirm = status.limit;
    },
  };

  const onInit = () => { };

  const onMounted = function () {
    this.excelModal = new Modal(document.getElementById("excel-output-modal"));
    this.bulkUpdateModal = new Modal(document.getElementById("bulk-update-modal"));
    this.loadRecords();
  };

  export default defineComponent({
    template: "#container",
    props: {},
    data: () => {
      return {
        userId: "",
        userName: "",
        email: "",
        modalUserId: "",
        modalUserName: "",
        modalEmail: "",
        masterData: "",
        excelModal: null,
        records: [],
        record: null,
        modalRecords: [],
        modalRecord: {},
        masterFields: [],
        targetList: [],
        target: {},
        masterField: null,
        groups:[],
        query: {
          limit: 20,
          offset: 0,
          columnName: "Id",
          direction: "asc",
          loginCode: "",
          userName: "",
          email: "",
          modalLoginCode: "",
          modalUserName: "",
          modalmail: "",
        },
        modalQuery: {
          loginCode: "",
          userName: "",
          email: "",
          modalLoginCode: "",
          modalUserName: "",
          modalmail: "",
        },
        modalLimit: 20,
        modalOffset: 0,
        modalLimitConfirm: 20,
        modalOffsetConfirm: 0,
        count: 0,
        modalCount: 0,
        filtering: false,
        modalFiltering: false,
        dispNotFound: false,
        dispNotFoundModal: false,
        bulkUpdateModal: null,
        isAllCheck: true,
        phase: 0,
        operation: "0",
        loading: false,
        summaryErrors: {},
      };
    },
    created: onInit,
    mounted: onMounted,
    methods: methods,
    computed: computed,
    components: {
      "sort-container": SortContainer,
      "pagination-nav": PaginationNav,
      "progress-nav": ProgressNav,
      "toast": AlertToast,
      "master-fields": MasterFieldsInput,
    },
  });
</script>
